import { useUpdateWorkspaceMemberV2Mutation, WorkspaceMembers } from '@/types/generated/graphql';
import { notification } from 'antd';

export const useEditWorkspaceMember = (
  cacheUpdateMember: (node: WorkspaceMembers) => void,
  handleCloseEdit: VoidFunction
) => {
  const [editMember, { loading: editMemberLoading }] = useUpdateWorkspaceMemberV2Mutation({
    onCompleted: (res) => {
      const { user, role } = res?.updateWorkspaceMemberV2?.data || {};
      notification.success({ message: res?.updateWorkspaceMemberV2?.message });
      cacheUpdateMember({
        id: res?.updateWorkspaceMemberV2?.data?.userWorkspace?.id,
        user: user,
        roles: [role ?? {}],
      });

      handleCloseEdit();
    },
    refetchQueries: ['CountMembers'],
    onError: (error) => {
      notification.error({ message: error.message });
    },
  });

  return { editMember, editMemberLoading };
};
